import { alpha, styled } from '@mui/material/styles';

export const Root = styled('div')<{ isDragActive: boolean }>(({ isDragActive }) => ({
  position: 'relative',
  height: '100%',
  ...(isDragActive && {
    '& .attachment-dropzone': {
      pointerEvents: 'all',
      opacity: 1,
    },
  }),
}));

export const AttachmentDropzone = styled('div')(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  boxShadow: `0px 0px 4px 0px ${theme.palette.primary.main}`,
  border: `1px solid ${theme.palette.primary.main}`,
  background: alpha(theme.palette.primary.darker, 0.1),
  zIndex: 29,
  pointerEvents: 'none',
  transition: 'opacity 0.3s',
  borderRadius: 8,
  opacity: 0,
}));

export const VisualAssist = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: '17%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  width: 321,
  padding: '14px 24px 14px 14px',
  border: `1px solid ${theme.palette.primary.main}`,
  boxShadow: `0px 0px 4px 0px ${theme.palette.primary.main}`,
  background: 'white',
  borderRadius: 8,
}));

export const IconWrapper = styled('div')(({ theme }) => ({
  padding: 20,
  color: theme.palette.primary.main,
  background: theme.palette.grey[90],
  borderRadius: 4,
}));

export const Text = styled('p')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.75,
  color: alpha(theme.palette.primary.darker, 0.8),
}));
